export const showHelpScoutBeacon = (): void => {
  const el = document.getElementById("beacon-container");
  el && el.classList.remove("invisible");
};

export const hideHelpScoutBeacon = (): void => {
  const el = document.getElementById("beacon-container");
  el && el.classList.add("invisible");
};
